import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function KeysIn({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Keys In" />
          </Col>
          <Col span={24}>
            <h2 className="red-info-heading">
              The goal is to inspect every property within 2 business days of
              the keys being turned in. If Gina is not able to assist you with
              this make time in your schedule to go to the property to do the
              inspection.
            </h2>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              If you are putting a lockbox be sure to place a codebox on the
              door only.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              **do not put a codebox if the owner is ending management. **{" "}
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              Be sure to record the codebox in appfolio on the "manage physical
              lockboxes" page
            </h3>
          </Col>
          <Col span={24}>
            <h2 className="red-info-heading">
              YOU MUST TAKE A PICTURE OF THE CODEBOX IN THE PROPERTY INSPECTION
              YOU COMPLETE!!
            </h2>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <h3 className="green-info-text">
                  email this message to the tenants in sayeagle
                </h3>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  Thank you for turning in your keys. We will begin the Security
                  Deposit refund process in the coming days unless you are a
                  part of a security deposit waiver program. You will receive
                  your deposit or invoice for damages in the mail in the coming
                  weeks unless you are a part of the security deposit waiver
                  program. We will update you once we have completed our
                  inspections and the property owner has reviewed the condition
                  of the home. Thank you for taking care of the property during
                  your time there.
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <h3 className="yellow-info-text">
                  email this to the owner in sayeagle
                </h3>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  The keys for the above unit have been turned in as part of the
                  move out process. We will be inspecting the unit and getting
                  an estimate for work needed if any to list it again. We will
                  be sure to share our results with you asap and appreciate your
                  patience as we inspect the home. Please let us know if you
                  have any questions along the way. Be aware that we will be
                  sure to bill the tenants security deposit for any damages
                  caused by the occupants as part of our move out process.
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default KeysIn;
